import { inject } from '@angular/core';
import { TeamsService } from '@teams/infra';
import { map, Observable } from 'rxjs';
import { GetTeamPathParams, GetTeamResponse, HostDto, TeamMemberDto } from '@core-http';
import { GetTeamDetailsQueryResult } from './get-team-details.query-result';
import { TeamHost, TeamMember } from '../../../interfaces';

export class GetTeamDetailsQueryHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  teamDetails(teamId: string): Observable<GetTeamDetailsQueryResult> {
    const pathParams: GetTeamPathParams = { teamId };

    return this.teamsService.getTeamDetails(pathParams).pipe(map((dto: GetTeamResponse) => this.mapToQueryResult(dto)));
  }

  private mapToQueryResult(dto: GetTeamResponse): GetTeamDetailsQueryResult {
    return {
      teamId: dto.teamId,
      teamName: dto.teamName,
      thumbnail: dto.thumbnail,
      host: this.mapHost(dto.host),
      members: dto.members.map((member: TeamMemberDto): TeamMember => this.mapMember(member)),
      memberRole: dto.memberRole,
      invitationToken: dto.invitationToken ?? ''
    };
  }

  private mapHost(host: HostDto): TeamHost {
    return {
      hostId: host.hostId,
      displayName: host.displayName,
      thumbnail: host.thumbnail,
      phone: host.phone
    };
  }

  private mapMember(member: TeamMemberDto): TeamMember {
    return {
      userId: member.userId,
      displayName: member.displayName,
      thumbnail: member.thumbnail ?? '',
      isAutoApproved: member.isAutoApproved,
      memberRole: member.memberRole
    };
  }
}
